import React from 'react';
import { Hero } from '../components/Hero';
export function HomePage() {
  return <>
    <meta name="google-site-verification" content="sk6TP432uU9oUEKeqevAxAjJz1Dfx4IYpI_VN6WAlpc" data-id="element-251" />
      <Hero data-id="element-252" />
    </>;
}